import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { PlanService } from "@core/store/plan/plan.service";
import { PatientsService } from "@core/store/patient/patient.service";
import { DocumentsService } from "@core/store/document/document.service";
import { TranslateModule } from "@ngx-translate/core";
import { DiagnosisService } from "@core/store/plan-editor/diagnosis/diagnosis.service";
import { DiagnosisWidgetService } from "@core/store/plan-editor/diagnosis/diagnosis-widget.service";
import { PlanService as PlanStageService } from "@core/store/plan-editor/plan/plan.service";
import { PlanWidgetService } from "@core/store/plan-editor/plan/plan-widget.service";
import {
  DndModule,
  DragDropConfig,
  DragDropService,
  DragDropSortableService,
} from "ng2-dnd";
import { DescriptionService } from "@core/store/description/description.service";
import { DiagnosisConditionsService } from "@core/store/plan-editor/diagnosis/diagnosis-conditions.service";
import { DiagnosisDescriptionsService } from "@core/store/plan-editor/diagnosis/diagnosis-descriptions.service";
import { PlanTreatmentsService } from "@core/store/plan-editor/plan/plan-treatments.service";
import { PlanDescriptionsService } from "@core/store/plan-editor/plan/plan-descriptions.service";
import { ReportService } from "@core/store/plan-editor/report/report.service";
import { S3Service } from "@core/services/s3.service";
import { PriceManagerService } from "@core/store/plan-editor/plan/plan-price.service";
import { InlineEditorModule } from "@qontu/ngx-inline-editor";
import { PriceService } from "@core/store/price/price.service";
import { SettingsService } from "@core/store/settings/settings.service";
import { WindowRefService } from "@core/services/window.service";
import { ReportPreviewService } from "@core/store/plan-editor/report/report-preview.service";
import { MaterialModule } from "../material/material.module";
import { SafeHtmlPipe } from "./pipes/safe-html-pipe";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TeethNumberingPipe } from "@app/shared/pipes/teeth-numbering.pipe";
import { JoinPipe } from "./pipes/join.pipe";
import { FileDropModule } from "ngx-file-drop";
import { LanguageSwitcherComponent } from "@app/shared/components/language-switcher/language-switcher.component";
import { LanguageSwitcherDropdownComponent } from "@app/shared/components/language-switcher-dropdown/language-switcher-dropdown.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthInterceptor } from "@core/services/auth.interceptor";
import { AccountService } from "@core/store/account/account.service";
import { MatTooltipModule } from "@angular/material";
import { ColorSelectorComponent } from "./components/color-selector/color-selector.component";
import { ColorPickerModule } from "ngx-color-picker";
import { CustomTreatmentService } from "@app/core/store/custom-treatment/custom-treatment.service";
import { PositionSortPipe } from "./pipes/position-sort.pipe";

@NgModule({
  imports: [
    CommonModule,
    DndModule,
    InlineEditorModule,
    HttpClientModule,
    FileDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    ColorPickerModule,
  ],
  declarations: [
    SafeHtmlPipe,
    TeethNumberingPipe,
    JoinPipe,
    PositionSortPipe,
    LanguageSwitcherComponent,
    LanguageSwitcherDropdownComponent,
    ColorSelectorComponent,
  ],
  providers: [
    PlanService,
    PatientsService,
    CustomTreatmentService,
    DocumentsService,
    DescriptionService,
    DatePipe,
    DiagnosisService,
    DiagnosisWidgetService,
    DiagnosisConditionsService,
    DiagnosisDescriptionsService,
    PlanStageService,
    PlanWidgetService,
    PlanTreatmentsService,
    PlanDescriptionsService,
    ReportService,
    S3Service,
    DragDropService,
    DragDropConfig,
    DragDropSortableService,
    PriceService,
    AccountService,
    PriceManagerService,
    ReportPreviewService,
    SettingsService,
    WindowRefService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [
    TranslateModule,
    MaterialModule,
    DndModule,
    SafeHtmlPipe,
    TeethNumberingPipe,
    JoinPipe,
    PositionSortPipe,
    FileDropModule,
    LanguageSwitcherComponent,
    LanguageSwitcherDropdownComponent,
    MatTooltipModule,
    ColorSelectorComponent,
    ColorPickerModule,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// /app/src/app/shared/shared.module.ts